"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultVenueImageUrls = void 0;
var DefaultVenueImageUrls;
(function (DefaultVenueImageUrls) {
    DefaultVenueImageUrls["Venue"] = "https://storage.googleapis.com/sellout-assets/default-images/venue/venue.jpg";
})(DefaultVenueImageUrls = exports.DefaultVenueImageUrls || (exports.DefaultVenueImageUrls = {}));
;
//# sourceMappingURL=DefaultVenueImageUrls.js.map